module.exports = __webpack_public_path__ + "static/zachowawcza-8604c4cacaa7d9f5066f9144f70349ee.svg";